import { useQuery } from "@tanstack/react-query";
import {
  getBundleDiscrepancies,
  BundleDiscrepancyParams,
} from "../services/get-bundle-discrepancies";

export function useBundleDiscrepancies(params: BundleDiscrepancyParams) {
  return useQuery({
    queryKey: ["bundle-discrepancies", params],
    queryFn: () => getBundleDiscrepancies(params),
    staleTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
  });
}
